import { render, staticRenderFns } from "./matrixTable.vue?vue&type=template&id=2fc5201c&scoped=true&"
import script from "./matrixTable.vue?vue&type=script&lang=js&"
export * from "./matrixTable.vue?vue&type=script&lang=js&"
import style0 from "./matrixTable.vue?vue&type=style&index=0&id=2fc5201c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5201c",
  null
  
)

export default component.exports